import { getSetupLayanan } from "api";
import { useCallback, useEffect } from "react";
import { useJwt } from "react-jwt";
import { useDispatch, useSelector } from "react-redux";
import { setSetupLayanan } from "redux/slices/setupLayanan";
import { getCookieToken, getSessionToken } from "utils/helpers";

const useGetData = () => {
  const token = getSessionToken() || getCookieToken();
  const { decodedToken = "" } = useJwt(token);
  const isSetup = useSelector(({ setupLayanan }) => setupLayanan.value);

  const dispatch = useDispatch();
  const action = setSetupLayanan;

  const doSet = useCallback((data) => dispatch(action(data)), [dispatch, action]);

  useEffect(() => {
    const getData = async () => {
      const { data } = await getSetupLayanan();
      if (data && Object.keys(data).length) doSet(data);
    };
    if (decodedToken && !isSetup) getData();
  }, [decodedToken, doSet, isSetup]);
};

export default useGetData;
